"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pindexList = void 0;
var type_system_1 = require("../../../type_system/index.js");
var bool_1 = require("../../builtins/bool/index.js");
var intBinOpToBool_1 = require("../../builtins/int/intBinOpToBool.js");
var list_1 = require("../../builtins/list/index.js");
var papp_1 = require("../../papp.js");
var perror_1 = require("../../perror.js");
var pfn_1 = require("../../pfn.js");
var phoist_1 = require("../../phoist.js");
var precursive_1 = require("../../precursive/index.js");
var pInt_1 = require("../int/pInt.js");
function pindexList(elemsT) {
    return (0, phoist_1.phoist)((0, precursive_1.precursive)((0, pfn_1.pfn)([
        (0, type_system_1.fn)([(0, type_system_1.list)(elemsT), type_system_1.int], elemsT),
        (0, type_system_1.list)(elemsT),
        type_system_1.int
    ], elemsT)(function (self, list, idx) {
        // TODO this "pif" is useless
        return (0, bool_1.pif)(elemsT).$(list_1.pisEmpty.$(list)
            .strictOr(intBinOpToBool_1.plessInt.$(idx).$((0, pInt_1.pInt)(0))))
            .then((0, perror_1.perror)(elemsT, "pindexList"))
            .else((0, bool_1.pif)(elemsT).$((0, pInt_1.pInt)(0).eq(idx))
            .then((0, list_1.phead)(elemsT).$(list))
            .else((0, papp_1.papp)((0, papp_1.papp)(self, (0, list_1.ptail)(elemsT).$(list)), (0, pInt_1.pInt)(-1).add(idx))));
    }, "pindexList")));
}
exports.pindexList = pindexList;
